export default __webpack_public_path__ + "static/media/verhuur-beheer-cover-foto.53296508.webp";